module.exports = (__webpack_require__(4))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/extends.js from dll-reference vendorProd_library
// module id = 36
// module chunks = 42